import React from 'react';

import Carousel from '../components/Carousel';

import {
  // ParallaxFigCaption,
  HeadingBox,
  ContentBox,
  PageContent,
  TableOfContents
} from '../css/_styledComponents';
// import RevealOnScroll from '../components/RevealOnScroll';
import { Parallax, Background } from 'react-parallax';
import BackToTop from '../components/BackToTop';
import Figure from '../components/Figure';
import virgilJohnsonHunting from '../images/9Johnsonhunting.jpg';
import babyPhoto from '../images/familyphotos/baby.jpg';
import virgilels1912 from '../images/familyphotos/virgilels1912.jpg';
import virgWithParentsEllsAndEv from '../images/familyphotos/virgWithParentsEllsAndEv.jpg';
import vj02 from '../images/familyphotos/VJ_02.jpg';
import vj13 from '../images/familyphotos/VJ_13.jpg';
import virgilscar from '../images/familyphotos/virgilscar.jpg';
import vj05 from '../images/familyphotos/VJ_05.jpg';
import helen2 from '../images/familyphotos/Helen2.jpg';
import vj07 from '../images/familyphotos/VJ_07.jpg';
import weddingphoto from '../images/familyphotos/weddingphoto.jpg';
import newlyweds from '../images/familyphotos/newlyweds.jpg';

import vj14 from '../images/familyphotos/VJ_14.jpg';
import millers from '../images/familyphotos/millers.jpg';
import alanswedding from '../images/familyphotos/alanswedding.jpg';
import podium from '../images/familyphotos/podium.jpg';
import vj06 from '../images/familyphotos/VJ_06.jpg';
import fishing from '../images/familyphotos/fishing.jpg';
import johnsonFishing from '../images/9Johnsonfishing.jpg';
import johnsonVivians from '../images/9JohnsonVivians.jpg';
import trio from '../images/familyphotos/trio.jpg';
import picnic from '../images/familyphotos/picnic.jpg';
import graduation1991 from '../images/familyphotos/1991graduation.jpg';
import newspaper from '../images/familyphotos/newspaper.jpg';
import vfw from '../images/familyphotos/vfw.jpg';
import funeral from '../images/familyphotos/funeral.jpg';
import theClaim from '../images/familyphotos/TheClaim-HardingSouthDakota.jpg';
import episcopalChurch from '../images/GethsemaneEpiscopalChurchMpls.jpg';
import chuckKausel from '../images/ChuckMarshallHighSchoolGraduation-1928.jpg';
import VirgNorthHigh from '../images/VirgNorthHighSchoolGraduation-1930.jpg';
import OwnerFredericandIrene from '../images/familyphotos/OwnerFredericandIrene.jpg';
import familyReunion from '../images/familyphotos/familyReunion.jpg';
import hockeyHallOfFameBuilding from '../images/Hockey_Hall_of_Fame.jpg';
import fishingDocks from '../images/familyphotos/fishingDocks.jpg';
import colfaxAveNorthHouse from '../images/familyphotos/colfaxAveNorthHouse.jpg';
import dinnerAtEddieBarnes from '../images/familyphotos/dinnerAtEddieBarnes.jpg';
import VirgSkateLoop from '../images/familyphotos/VirgSkateLoop.mp4';
import stadiumDemo from '../images/ChicagoStadiumDemolition_March_1995.jpg';
import houseOnChocolateAve from '../images/familyphotos/houseOnChocolateAveHershey.jpg';
import VirgSignedFootballPhoto from '../images/VirgSignedFootballPhoto.jpg';
import HighschoolHockey1928 from '../images/HS_Hockey_1928.jpg';

import family1971 from '../images/familyphotos/family1971.jpg';

import PicnicVirgEvAndElls from '../images/PicnicVirgEvAndElls.jpg';


import DianeCindyVirgVirg from '../images/familyphotos/DianeCindyVirgVirg.jpg';
import MarthaAndAlanSr from '../images/familyphotos/MarthaAndAlanSr.jpg';
import theMinkBowTie from '../images/familyphotos/theMinkBowTie.jpg';

import jerseyFront from '../images/CinderellaTeamJersey-1937-1938_front.jpg';
import jerseyBack from '../images/CinderellaTeamJersey-1937-1938_back.jpg';
import LouieAndVirg_1926 from '../images/familyphotos/LouieAndVirg_1926.jpg';

import pillsburyAvenueHouse from '../images/familyphotos/pillsburyAvenueHouse.jpg'
import nicolletAvenueHouse from '../images/familyphotos/nicolletAvenueHouse.jpg'
import tonkaBayHouse from '../images/familyphotos/tonkaBayHouse.jpg'

import alanBeverlyWedding from '../images/familyphotos/alanBeverlyWedding.jpg';
import graysBayHouseWayzata from '../images/familyphotos/graysBayHouseWayzata.jpg';

import virgAndFriends from '../images/familyphotos/virgAndFriends.jpg';
import theDiningRoom from '../images/familyphotos/theDiningRoom.jpg';
import celebrantsSeated from '../images/familyphotos/celebrantsSeated.jpg';
import alanBeverlyWeddingDay from '../images/familyphotos/alanBeverlyWeddingDay.jpg';
import alanBeverlyCutTheCake from '../images/familyphotos/alanBeverlyCutTheCake.jpg';
import JohnnyAndHollyAnneJohnson from '../images/familyphotos/JohnnyAndHollyAnneJohnson.jpg';


import johnnyAndHelen from '../images/familyphotos/johnnyAndHelen.jpg';
import provincetownPlayhouse from '../images/familyphotos/provincetownPlayhouse.jpg';
import oldManAndTheSea from '../images/familyphotos/oldManAndTheSea.jpg';
import johnnyGraduation from '../images/familyphotos/johnnyGraduation.jpg';
import AlanAlanJrCarolyn from '../images/familyphotos/AlanAlanJrCarolyn.jpg';
import orleansTheater from '../images/familyphotos/orleansTheater.jpg';

import valVivVirgMarion from '../images/familyphotos/valVivVirgMarion.jpg';
import elmerEvAgnesVirgAlanVivVal_1956 from '../images/familyphotos/elmerEvAgnesVirgAlanVivVal_1956.jpg';
import deerLakeWI_1963 from '../images/familyphotos/deerLakeWI_1963.jpg';
import ushhf from '../images/familyphotos/USHHF.jpg';

// import VirgHersheyBears from '../images/VirgHersheyBears.jpg';
//Virg Johnson, Defense Player for the Hershey Bears.
// import highschool from '../images/familyphotos/highschool.jpg';
// // photo #2
// import virgAndEvelyn from '../images/familyphotos/VirgAndEvelynJohnson-1913.jpg'
// // 'Virg and Evelyn Johnson June 1913'
// //photo 5
// import woolSweater from '../images/CinderellaTeamJersey-1937-1938.jpg';
// // photo 6
// import newDeal from '../images/StPaul_newDeal_hockeyTeam-1939.jpg'
// // 'St. Paul&apos;s &quot;New Deal&quot; Hockey Team Signed photo 1939'


function PersonalHistory () {
  return (
    <PageContent>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '0',
          paddingBottom: '40%',
          overflow: 'hidden'
        }}
      >
        <h1 className="vjTitle" >
          VIRGIL SYLVESTER JOHNSON
        </h1>
        <video
          style={{
            position: 'absolute',
            minWidth: '280px',
            width: "calc(100vw - 40px)",
            height: 'auto',
            top: '50%',
            transform: 'translate(0, -50%)'
          }}
          loop
          autoPlay
          muted
        >
          <source src={VirgSkateLoop} type="video/mp4" />
        </video>
      </div>

      
      <TableOfContents>
          <tbody>
            <tr>
              <td>
                <a href="#part1" className="part">
                  Part I:
                </a>
              </td>
              <td>
                <a href="#part1" className="desc">
                  The Early Years 1909-1930
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="#part2" className="part">
                  Part II:
                </a>
              </td>
              <td>
                <a href="#part2" className="desc">
                  The Depression and WWII years 1930-1945
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="#part3" className="part">
                  Part III:
                </a>
              </td>
              <td>
                <a href="#part3" className="desc">
                  Family Life at Lake Minnetonka 1945-1993
                  <br />
                  The Induction into the Hockey Hall of Fame 1974
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="#part4" className="part">
                  Part IV:
                </a>
              </td>
              <td>
                <a href="#part4" className="desc">
                  Finale
                </a>
              </td>
            </tr>
          </tbody>
      </TableOfContents>

      <ContentBox type="white" id="part1">
        <HeadingBox>
          <Figure
            img={theClaim}
            caption='The Claim, Harding Co., South Dakota Virg seated on his mother&apos;s lap (UL) 1910'
          />
          <h2>
            Part I: The Early Years 1909-1930
          </h2>
        </HeadingBox>
        <p>
          The periodic moves between Minnesota and the Dakotas in the first years of his
          life certainly prepared Virgil Johnson for the nation-trotting life of a
          professional hockey player. Indeed, he looks out at us seated atop farming
          equipment in the Dakotas or from the photographer&apos;s studio in Minneapolis
          with an attitude of wonder and expectation.
        </p>
      </ContentBox>
     

      <ContentBox>
        <Figure
          left
          img={babyPhoto}
          caption='Baby picture 1909 - S.P. Eggan Photo'
        />
        <p>
          Virgil Sylvester Johnson was born on March 4, 1909 in Minneapolis,
          Minnesota. (Please note that he frequently listed his birth date as
          1912 to &quot;extend his professional hockey career&quot;.) Virgil (Virg) was the
          younger brother to Ellsworth Charles (Ells) who was born in 1907. Their
          parents were Elmer Andrew Johnson and Agnes C. Trantina. The Johnsons lived
          in the Camden neighborhood in North Minneapolis amid a vast number of close
          relatives. Elmer worked as a carpenter for the Mereen-Johnson factory from
          1922 until his retirement in 1954. Virg&apos;s paternal grandparents had emigrated
          from Husum, Sweden in 1881 and operated a large boarding house for Scandinavian
          lumbermen and their families on Aldrich Avenue North. This location became a meeting
          place for both sides of his family. His favorite memory of the boarding house
          was the dining hall and the &quot;big holiday parties&quot; with his grandmother&apos;s
          &quot;home cooked Swedish meals.&quot; His maternal grandparents lived by the Mississippi
          River at 2111 3rd Street South. They had emigrated from Drahotesic, Bohemia in
          1883. His grandfather worked as a bran packer for the
          Consolidated Milling Co. in Minneapolis.
        </p>
      </ContentBox>


      <ContentBox flankingImages type="white">
        <Figure
          left
          img={virgilels1912}
          caption='Virg and Ells October 1912 - S.P. Eggan Photo'
        />
        <Figure
          right
          img={virgWithParentsEllsAndEv}
          caption='Virg (center) with his parents, Ells, and Ev 1918 - S.P. Eggan Photo'
        />
        <p>
          The Johnson family group was complete with the birth of Virg's sister, Evelyn
          Agnes (Ev), in 1911 on the claim in Harding County, South Dakota. When the Johnson family
          decided to quit homesteading after three unprofitable years in 1912, Agnes
          moved her family permanently back to Minneapolis. The Johnsons really were
          "city people" as Virg was to note later during the depression
          years. In 1933, he took summer employment at his Uncle Jim Craigie's wheat
          ranch in Montana. Amid the drought and hailstorms, he wrote home, "I
          never saw such long hours, five in the morning until eight at night. I get
          up at 3:30 or 4 o'clock - no farm for Johnson's son Virgil - that's for
          sure."
        </p>
        <p>
          &quot;He was so cute,&quot; his cousin Annabelle Jensen remembered. &quot;Virg
          wasn&apos;t large, with blue eyes and blond hair. He was so personable and
          easy going.&quot; His manner with the girls was different from his roughhousing
          with the boys. One day five year old Annabelle walked home from school
          and came upon a pack of rowdy boys, &quot;Virg appeared, took my arm, smiled and
          walked me past the danger without an incident.&quot; Virg was
          admired by his &quot;sisters, aunts, and cousins, he had them by the dozens&quot;
          throughout his life. Annabelle&apos;s sister, Loraine McCarthy, admired his
          &quot;free spirit.&quot; She felt Virg comfortably moved through life
          with his own agenda. Although he was &quot;the best dancer I ever met&quot;,
          his wife, Helen, noted &quot;don&apos;t try to get your father Virg
          to do anything he doesn&apos;t want to do. You won&apos;t budge him&quot;.
          Of course, his biggest fan was his mother. Agnes&apos; attendance at
          sporting events from high school through the hockey years was noted by
          Annabelle, &quot;my aunt appeared bundled up at every game even in the
          coldest weather&quot;. Agnes kept every newspaper article and picture
          in which Virg was featured pasted in scrapbooks, much to our delight in
          preparing this biography.
        </p>
      </ContentBox>


      <ContentBox flankingImages>
        <Figure
          left
          img={vj02}
          caption='Virg and Ells First Holy Communion 1918 - S.P. Eggan Photo'
        />
        <Figure
          right
          img={colfaxAveNorthHouse}
          caption='3955 Colfax Avenue North, Minneapolis'
        />
        <p>
          Ells and Virg made their first holy communion at St. Bridget&apos;s Church in 1918.
          They wore navy blue serge Norfolk suits with knickers. After World War I
          Elmer and Agnes planned their new home that was to be built at 3955 Colfax
          Avenue North. This two-story timber and stucco house was built over a two-year
          period by Elmer and his two brothers, Merrette and Emil Johnson. They were
          all skilled carpenters, a craft that Ells and Virg were expected to develop
          and which served Virg well in his later working years. The interior woodwork
          was oak in the popular craftsman &quot;arts and crafts style&quot;. The
          family moved into their new home in 1924. Virg and Ells shared one of the
          three upstairs bedrooms. In time the three children attended and graduated
          from North High School.
        </p>
      </ContentBox>

      <ContentBox type="white">
        <Figure
          left
          img={VirgSignedFootballPhoto}
        />
        <Figure
          right
          img={vj13}
          caption='Virg (right) Receiving the Rabbit&apos;s Foot 1928 North High Yearbook'
        />
        <p>
          Virg tried out for every sport during his high school years. He played baseball.
          He played football. He also played hockey in &apos;26, &apos;28 and coached the team
          in &apos;29. He won letters (&quot;N&quot; for North High) for football AND hockey.
          Even elected to the Student Council in &apos;28, he proved to be a popular classmate!
          His classmates included Lauretta (Mrs. Earl) Bartholome, a life-long friend.
          Standing 5&apos; 8&quot; tall, weighing 153 pounds, with blue eyes and
          wavy blonde-brown hair parted in the middle, Virg did not appear to have
          the physique we recognize today as jock material.
        </p>
        <p>
          Though acknowledged as a developing athlete, he took his time matriculating through
          the labyrinth of studies. &quot;I never wanted to give up being North&apos;s
          football captain.&quot; As quarterback (&apos;26,&apos;27), captain in
          &apos;28 and assistant coach in &apos;29 of the football team, he became
          a school hero. He was a talented team leader. Men looked up to him for direction
          and followed him. &quot;You could not walk down a street in Minneapolis
          without Virg stopping to greet a relative, former classmate, or a fan.&quot;
          He was very, &quot;Hail fellow, well met!&quot; Helen remembered. One school
          photograph shows him performing the symbolic rite entitled &quot;The Rabbit&apos;s
          Foot Is Passed Along.&quot; The outgoing captain Clarence Munn passed the furry 
          good luck charm to Virg for the coming season.
        </p>
      </ContentBox>


      <ContentBox
        type="black"
        className="flexImages"
      >
        <Figure
          fullWidth
          img={HighschoolHockey1928}
          // caption="North High Hockey Team, Virgil Johnson seated second from left"
        >
          <div
            className='highlightFace'
            style={{
              position: 'absolute',
              top: '28.5%',
              left: '29.7%',
              zIndex: '1',
              width: '12%',
              height: '0',
              paddingBottom: '10%'
            }}
          >
            <svg
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="50 0 100 100"
            >
              <circle cx="100" cy="50" r="40" stroke="var(--color-frame)" strokeWidth="4" fill="none" />
            </svg>
          </div>
        </Figure>
      </ContentBox>


      <ContentBox flankingImages>
        <Figure
          left
          reveal="left"
          style={{ flex: '1' }}
          img={chuckKausel}
          caption='Chuck Marshall High School Graduation 1929 The Miller Studios, Minneapolis'
        />
        <Figure
          right
          reveal="right"
          style={{ flex: '1' }}
          img={VirgNorthHigh}
          caption='Virg North High School graduation 1930 David Banks Photo'
        />
        <p>
          Family loyalties were divided, however, when his team played John Marshall
          High School whose captain was his cousin, Chuck Kausel. After securing a mountain
          of trophies for North High, Virg graduated in 1930 at the beginning of the
          Great Depression. Over the years he attended many class reunions
          and was still remembered by those classmates who attended his funeral in 1993.
          The caption on his yearbook photo reminded classmates, "He may not be hot with a waffle
          iron--- but, oh boy, on the gridiron."
        </p>  
        <p>
          Chuck Kausel was an all round athelete in football, baseball, hockey, track, and was president of his
          senior class. After graduation in 1929, he went into the family foundry business 
          in Minneapolis.
        </p>
      </ContentBox>

      <ContentBox type="white" id="part2">
        <HeadingBox>
          <Figure
            img={virgilscar}
            caption='Virg with his 1931 Ford Model A Roadster'
          />
          <h2>
            Part II: The Depression and WWII years 1930-1945
          </h2>
          <p>
            The generation that came of age during the financial collapse of the 1930&apos;s 
            was later faced with the ominous uncertainties of World War II. 
            Virg and Helen were lucky in that they had steady employment throughout this time. 
            Virg played for one team or the other continually from 1930 to 1945. 
            He lived with his parents, Elmer and Agnes Johnson, at 3955 Colfax Avenue North, 
            Minneapolis until his marriage.  Virg always loved cars. 
            From his Ford Model A Roadster in 1931 to his futuristic black and white Mercury 
            in the mid-1950&apos;s he had a passion for long distance. 
            His Mercury had heavy chrome in the front and back, two toned sides, and windows 
            that went up and down with push buttons. Helen had studied court reporting in Chicago 
            after high school. She worked as a stenographer in Minneapolis until her marriage in 1936. 
            She lived with her father, Fred R. Emmings, at 3415 Pillsbury Avenue South before and after her wedding. 
            The Emmings house was their base throughout the hockey years because their life together 
            became one of sports team travels around the country.  Virg had his summers off from hockey practice. 
            One of his best summer jobs was mowing grass with his hockey buddy, Hub Nelson, at Lakewood Cemetery. 
            Virg and Helen bought a plot there in the early 1940&apos;s.
          </p>
        </HeadingBox>
      </ContentBox>


      <ContentBox
        type="black"
        className="flexImages"
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}
      >
        <Figure
          reveal="left"
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          img={vj05}
          caption='Virg on roller skates Minneapolis Arena, 1932'
        />

        <Figure
          reveal
          oval
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          img={newlyweds}
          caption='Virg and Helen, newlyweds at Lake Superior July 04, 1936'
        />

        <Figure
          reveal="right"
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          img={helen2}
          caption='Helen in jodhpurs Minneapolis Riding Academy, 1929'
        />
      </ContentBox>

      <ContentBox>
        <Figure
          right
          img={vj07}
          caption='At the Emmings&apos; 1934 - Cully Dahlstrom, Virg, Oren Emmings, Don Olson, and Cliff Purpur'
        />
        <p>
          Virg met Helen Elizabeth Emmings about 1932. The Minneapolis Skating Arena
          was adjacent to the horse stables and Riding Academy. In these two ovals,
          Virg skated and Helen rode her favorite horses, Rex and Fidgits. She was
          the head stenographer at the Russell Miller (flour) Milling Co., a position
          she had held since the late 1920&apos;s. Her father, Fred R. Emmings, was the
          representative for Chicago Paints with the Breinig Paint Co. in Minneapolis.
        </p>
        <p>
          The Emmings house was a large white three story frame house c. 1910 in south Minneapolis. 
          It became a center for the hockey and horse crowd. 
          Helen&apos;s friend, Roselle Vogen, lived with them. Hockey star, Cliff &quot;Fido&quot;
          Purpur, lived there in 1934 noting, &quot;I stayed with the Emmings family
          one of my seasons with the Minneapolis Millers. I used to go with your mother&apos;s
          brother, Oren, to Hopkins and play cribbage for beers. The Emmings treated
          me like a King and I was just a young guy from North Dakota.&quot;
        </p>
      </ContentBox>

      <ContentBox flankingImages type="white">
        <Figure
          left
          img={weddingphoto}
          caption='Helen and Virg 1936 - Zintsmaster Photo'
        />
        <Figure
          right
          img={episcopalChurch}
          caption='Gethsemane Episcopal Church, Minneapolis'
        />
        <blockquote>
          Virg Johnson Joins Ranks of Benedicts – 
          Virgil Johnson, a former North high athlete and an outstanding American Hockey 
          Association defenseman with St. Paul has deserted single blessedness, it was 
          revealed yesterday with announcement of his marriage to Miss Helen Emmings of 
          Minneapolis.  They are living at Island Park, Lake Minnetonka, for the summer.
          <span className="cite">- The Minneapolis Star; June 4, 1936</span>
        </blockquote>
        <p>
          &quot;Virgil and I were married on May 23, 1936 in Gethsemane Episcopal Church in
          downtown Minneapolis late in the afternoon. The reception was at Grandpa&apos;s House
          at 3415 Pillsbury. Many, many people were there. Three hundred dinners were
          served. Helen Breckheimer was my maid of honor. Cully stood up for your
          father. I did not wear a veil, I was over 30, you know, and no bouquet,
          only a prayer book. My dress was blue lace, not white! And only two bridesmaids,
          it was the depression, there was not much money in those days&quot;, Helen
          reminisced about her marriage to Virg in 1985, almost fifty years later.
        </p>
      </ContentBox>

      {/* <ContentBox>
        summer home section To come
      </ContentBox> */}

      <ContentBox flankingImages>
        <Figure
          left
          img={vj14}
          caption='Helen, Johnny, and Virg En Route from Hershey, Spring 1943'
        />
        <Figure
          right
          img={houseOnChocolateAve}
          caption='&quot;Our half house on Chocolate Avenue in Hershey, spring of 1943&quot; - Helen wrote on the photo'
        />
        <p>
          The challenge of tournament travel excited Virg and Helen. A career in sports,
          and they were a motivated sports-minded couple, necessitated travel. Virg
          was a disciplined athlete. Helen noted during a contract dispute, &quot;you
          know Virg! He won&apos;t ever do or say anything that might cost him
          a chance to play hockey&quot;. They regularly moved households between
          Minneapolis, Hershey, Chicago, and Cleveland over a nine-year period.
          In 1939 after the Germans invaded Poland, their son Virgil Charles (Johnny) 
          was born followed by their daughter Holly Anne (Sissy) in 1940.
          {/* Virg was in hospital with hockey injuries when Holly
          died in a pneumonia epidemic in Minneapolis in 1942. He attended her funeral
          at Lakewood Cemetery in a wheelchair. */}
        </p>
      </ContentBox>

      <ContentBox type="white">
        <h3>Family Life Off The Ice</h3>
        {/* <p>
          Virg was voted &quot;Most Valuable Player&quot; for the American Hockey Association
          in 1942. After being contracted to the St. Paul Saints and the Hershey Bears.
        </p> */}
        <Figure
          right
          img={JohnnyAndHollyAnneJohnson}
          caption="Johnny and Sissy at the Riding Stable 1941"
        />
        <p>
          During the World War II years, all of Virg&apos;s fellow hockey players became 
          young fathers.  Because the families all lived in proximity to one another, either 
          privately in Minneapolis, or in the Hotel Guyon in Chicago, the children grew up 
          together.  At the hotel, the children had a &quot;wrangler&quot; who walked them, 
          hand-in-hand, over to nearby Garfield Park and Conservatory.  A special treat 
          would be to visit the Brookfield Zoo. Fred Emmings was a frequent visitor in Chicago. 
          His three sisters, Mollie, Elizabeth, and Gretchen lived there and hockey holidays were spent together.
          There was always a stable nearby for Helen to ride and Johnny and Sissy to pet the barn cats.
        </p>
      </ContentBox>
      <ContentBox
        type="black"
        className="flexImages"
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}
      >
        <div style={{ flex: '1', alignSelf: 'center' }}>
          <Figure
            reveal="right"
            style={{ width: 'calc(100% - 40px)', margin: '20px' }}
            img={nicolletAvenueHouse}
            caption="Johnny standing guard at the Nicollet Avenue House"
          />
          <Figure
            reveal="right"
            style={{ width: 'calc(100% - 40px)', margin: '20px', alignSelf: 'center' }}
            img={tonkaBayHouse}
            caption='In the lane, snow is glistening at the Tonka Bay House.'
          />
        </div>
        <Figure
          reveal="left"
          style={{ flex: '1', margin: '20px', alignSelf: 'center' }}
          img={pillsburyAvenueHouse}
          caption='Grandpa Emmings in the back yard of the Pillsbury Avenue House'
        />
      </ContentBox>
      <ContentBox type="black">
        <p>
          When in Minneapolis, the new parents, plus Johnny and Sissy, lived in their grandfather 
          Emmings house on South Pillsbury.  Virg was in hospital with hockey injuries 
          when Holly died in a 24-hour pneumonia epidemic in May 1942.  
          He attended her funeral at Lakewood Cemetery in a wheelchair. This house was a 
          gathering place for family and hockey friends throughout the war years.  
          In 1944 Fred sold the Pillsbury house and the family moved to a suburban 
          bungalow at 6715 South Nicollet Avenue while Virg and fellow carpenters 
          built the new post-war &quot;rambler&quot; at Tonka Bay, Lake Minnetonka.
        </p>
      </ContentBox>

      <Carousel />

      <ContentBox type="white" id="part3">
        <HeadingBox>
          <Figure
            img={hockeyHallOfFameBuilding}
            caption='Hockey Hall of Fame Museum, Eveleth MN'
          />
          <h2>
            Part III: Family Life at Lake Minnetonka 1945-1993
          </h2>
        </HeadingBox>
        <p>
          Earl Bartholome, who had also returned to Minneapolis and played with Virg with 
          the Millers, was now in building construction management, hired Virg as a carpenter
          for the Insulation Sales Co. in Minneapolis. His specialty was the installation
          of acoustical ceilings in public buildings. He traveled all over the midwest
          with carpenters supervising complex installations. Virg also did free
          lance construction through his own &quot;Virg Johnson Company&quot;.
          As a member of the Carpenter&apos;s union, Virg continued to work until his retirement
          at 65 in 1974 when his new income consisted of a Union Pension and Social Security.
        </p>
        <p>
          In 1950, the &quot;free spirit&quot; moved into his rebuilt summer cottage at Bantas Point, 
          Gray's Bay, Lake Minnetonka. He lived here for the rest of his life. Virg rented out dock 
          space to city boat owners.  Alan kept his Chris-Craft motorboat here as well for his 
          help putting in docks in the Spring and taking them out in the Fall. 
          As time passed the summer cottages along Bantas Point were demolished to make way for 
          prime property Mega Mansions.
        </p>
        <p>
          Helen, her father Fred Emmings, Johnny, and Alan David remained in Tonka Bay. 
          Virg and Helen were never divorced, the subject was never discussed, and they frequently 
          appeared together for family events and celebrations such as the induction 
          into the United States Hockey Hall of Fame in 1974.
        </p>
        <Figure
          fullWidth
          img={graysBayHouseWayzata}
          caption='Virg&apos;s low house and docks are dwarfed by the Mega Mansions on either side by 1990'
        />
      </ContentBox>

      <ContentBox>
        <h3>Golden Wedding Celebration September 4, 1956</h3>
        <blockquote>
          Mr and Mrs Elmer A. Johnson, 3955 Colfax avenue N, will observe their 50th wedding anniversary 
          with an open house in their home from 2 to 5 p.m, Sunday, September 4. 
          No cards have been sent.
          <span className="cite">- Minneapolis Star, Aug, 24, 1956</span>
        </blockquote>
        <p>
          Virg&apos;s parents were married in Minneapolis at Our Lady of Perpetual Help up the hill from the Bohemian Flats. 
          Elmer&apos;s brother, Merrette, and Agnes&apos; sister, Amelia, stood up for them. 
          Rev. Matthew Sampson presided with a reception at the Johnson Boarding house. 
          There were several family get togethers in preparation for the Open House celebrating Elmer and Agnes. 
          Their children, grandchildren and families, cousins, siblings and longtime friends all came bearing good wishes. 
          And gifts.
        </p>
        <div
          className="flexImages"
          style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}
        >
          <Figure
            reveal="left"
            style={{ flex: '1', margin: '20px' }}
            img={virgAndFriends}
            caption='Virg, Elmer, Ells, and Agnes Johnson and Evelyn Johnson White (front)'
          />
          <Figure
            img={theDiningRoom}
            style={{ flex: '1', margin: '20px' }}
            caption='The dining room L-R:  Vivian White, Val White, Evelyn White, Eddie Barnes, Grandpa Elmer and Grandma Agnes Johnson'
          />
          <Figure
            reveal="right"
            style={{ flex: '1', margin: '20px' }}
            img={celebrantsSeated}
            caption='Celebrants Seated front: Uncle Emil, Evelyn, Aunt Anna, Aunt Rose.  Back Row: Helen with Duane, Jerre Leonard,  Lloyd Leonard holding Agnes, Johnny Barnes, Ells, Eddie Barnes, Virg, and Elmer.'
          />
        </div>
      </ContentBox>
      
      <ContentBox type="white" flankingImages>
        <h3>Graduation, Boston University June 1961</h3>
        <Figure
          left
          img={johnnyGraduation}
          caption='Johnny&apos;s Graduation, Boston University.'
        />
        <Figure
          right
          img={johnnyAndHelen}
          caption='Johnny and Helen at Old North Church, Boston.'
        />
        <p>
          Johnny graduated from Boston University in the Spring 1961. Virg and Helen flew out to 
          Boston for the &apos;event that was held in the Boston Garden. 
          They toured Boston University, Virg met with Boston Bruins hockey aficionados, 
          they ate dinner at Durgin Park, Helen and Johnny visited Old North Church and the 
          Paul Revere House.  Johnny graduated. Helen flew back to Minneapolis and Virg 
          treated Johnny to a stay on Cape Cod and New York City.  John F. Kennedy 
          had just become the 35th President and the Kennedy Compound at Hyannis Port was a destination. 
          Virg went ocean fishing for a day while Johnny visited college pals who were working in 
          summer theaters on the Cape. In New York, Virg and Johnny met with the honchos at the 
          New York Rangers who treated them to lunch at the Jack Dempsey Broadway Restaurant. 
          They flew back to Minnesota on a plane out of LaGuardia. This was the first plane trip 
          for Johnny as his four college years had all been &quot;travel by train&quot;.
        </p>
      </ContentBox>

      <ContentBox
        type="black"
        className="flexImages"
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}
      >
        <Figure
          reveal="left"
          img={provincetownPlayhouse}
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          caption='Mr. and Mrs. Demas, Virgil at the Provincetown Playhouse.'
        />
        <Figure
          img={oldManAndTheSea}
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          caption='The old man and the sea off Cape Cod.'
        />
        <Figure
          reveal="right"
          img={orleansTheater}
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          caption='Dennis Allen, Gordon Argo and his son, Johnny, Mr. Demas at the Orleans Theater'
        />
      </ContentBox>


      <ContentBox type="white">
        <h3>Deer Lake, Wisconsin</h3>
        <p>
          Weekends in the summer were spent at Cousin Viv and Val&apos;s summer house at Deer Lake. 
          The house sat up the hill from the lake, a lake that was good for swimming and fishing. 
          Viv, Ev, and Virg had a special bond.  Virg and Viv were born a month apart in 1909. 
          Viv and Ev had parallel histories, divorcing their first husbands and having a joint 
          wedding in July 1949 in Northwood, Iowa.  They married the brothers Val and Deac White. 
          The following year Deac, Ev and Ev&apos;s sons, Johnny and Eddie Barnes, moved to Puyallup, Washington. 
          Val and Viv stayed in Minneapolis with her two sons, Jim and Bob Anderson. 
          Deer Lake became a summer Mecca for the White, Johnson, and Anderson families.
        </p>
        <ContentBox
          type="white"
          className="flexImages"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
            paddingBottom: '0'
          }}
        >
          <Figure
            reveal="left"
            style={{ flex: '1', margin: '20px' }}
            img={valVivVirgMarion}
            caption='Val, Viv, Virg, and Marion 1964'
          />
          <Figure
            reveal
            oval
            style={{ flex: '1', margin: '20px' }}
            img={elmerEvAgnesVirgAlanVivVal_1956}
            caption='Elmer, Ev, Agnes, Virg, Alan, Viv, Val 1956'
          />
          <Figure
            reveal="right"
            style={{ flex: '1', margin: '20px' }}
            img={deerLakeWI_1963}
            caption='Bill and Serene Russell, Virg, Viv, Johnny 1963'
          />
        </ContentBox>
      </ContentBox>

      <ContentBox>
        <h3>Family Wedding 1967</h3>
        <p>
          On December 16, 1967 Alan David Johnson and Beverly Jean Wright were married by a 
          Justice of the Peace in Wayzata, Minnesota.  The family reception following was hosted 
          by the brides parents at their house at Chowen&apos;s Corner, Deephaven. 
          Virg and Helen joined Wilbur and Erma Wright greeting friends as parents of the wedded couple. 
        </p>
        <ContentBox
          className="flexImages"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
            paddingBottom: '0'
          }}
        >
          <Figure
            reveal="left"
            style={{ flex: '1', margin: '20px' }}
            img={alanBeverlyWeddingDay}
            caption='Alan David and Beverly Jean on their Wedding day'
          />
          <Figure
            reveal
            style={{ flex: '1', margin: '20px' }}
            img={alanBeverlyWedding}
            caption='Newlyweds Alan and Bev with parents, Virg and Helen at the Wrights.'
          />
          <Figure
            reveal="right"
            style={{ flex: '1', margin: '20px' }}
            img={alanBeverlyCutTheCake}
            caption='Newlyweds cut the cake'
          />
        </ContentBox>
      </ContentBox>



      <ContentBox flankingImages type="white">
        <h3>Grandchildren</h3>
        <Figure
          left
          img={family1971}
          caption='Bev, Alan, Virg, Helen with Carolyn, and Johnny 1971 - Lee Brothers Photo'
        />
        <Figure
          right
          img={AlanAlanJrCarolyn}
          caption='Alan with Alan Jr. and Carolyn'
        />
        <p>
          Virg and Helen&apos;s family was complete when Alan and Beverly&apos;s family grew to
          include the birth of Carolyn Jean and Alan David, Jr in the early 1970&apos;s. 
          The little family lived in a bungalow on Larchmore Avenue, not far from Bev&apos;s parents. 
          Later they moved to a more commodious house in Eden Prairie not far from Lake Minnetonka. 
          In the summer Alan was able to dock his wooden vintage Cris Craft at Virg&apos;s. 
          In the winter a skating rink was shoveled as seen in the film of Virg skating at the 
          beginning of this Personal History. The children attended and graduated from Eden Prairie schools.
        </p>
      </ContentBox>

      <ContentBox>
      <Figure
          right
          img={vj06}
          caption='Alan, Virg, and Johnny, Hockey Hall of Fame 1974'
        />
        <h3>United States Hockey Hall of Fame 1974</h3>
        <p>
          As a vital member of the Black Hawk&apos;s &quot;Cinderella Team&quot; and
          as a stalwart player for twenty-two years, Virg&apos;s contribution to hockey
          was recognized when he was enshrined in the United States Hockey Hall of Fame on October 26,
          1974. Among the eight other enshrinees were his old friends, Bill Moe, Vic Heyliger,
          Vic Des Jardins, and Cliff Purpur. The induction festivities included the enshrinement
          ceremony banquet presided over by Clarence Campbell, president of the
          National Hockey League. Devotees were reminded, &quot;that memories may
          never fade of flying puck and flashing blade&quot;. Virg cited the sport
          of hockey in his acceptance speech with a toast, &quot;On with the game!&quot;
          That evening guests were treated to the Enshrinement Hockey Game at the
          Hippodrome that pitted the University of Minnesota against the University
          of Minnesota-Duluth. An evening reception was held at the Eveleth Elks
          Club and VFW. Virg was joined at the event in Eveleth by Helen, his sons,
          and his extended family including the &quot;sisters, aunts, and cousins.&quot;
        </p>
        <Figure
          fullWidth
          img={ushhf}
          caption='Andy, Evelyn, Virg, Johnny, Ellsy, Rita, Dave, Helen, Viv, Ells, Serene, Matt at the USHHF'
        />
        </ContentBox>
        <ContentBox>
        <p>
          Coach Johnny Mariucci remembered Virg: &quot;He was one of the smallest defensemen
          in the league, but very effective. He was a magician with his stick. He
          was like a terrier after a rat when he moved in and stole the puck. He
          could do it against the best stick handlers.&quot;
        </p>

      </ContentBox>


      <ContentBox flankingImages type="white">
        <h3>The Sporting Life</h3>
        <Figure
          left
          img={fishing}
          caption='Virg (center) with Cousin Tom Novak (right) 1932'
        />
        <Figure
          right
          img={virgilJohnsonHunting}
          caption='Virg (left) with other deerstalkers. Mid 1980&apos;s'
        />
        <p>
          He enjoyed his working and retirement years with his second best sport, &quot;hunting
          and fishing&quot;. &quot;Thanks mother for the birthday gift, and you
          know what I&apos;m going to buy? Some fishing tackle!&quot; He collected
          tackle and guns and regularly loaned them out to fellow sportsmen.
        </p>
        <p>
          Trips with pals were made in search of game to Canada, the Dakotas and Northern
          Minnesota. Messrs. Hamms and Grain Belt accompanied them on these forays.
          The stories of these trips were legendary within the family. His nephew,
          David Johnson, remembers one camping and fishing trip to Lake Winnibigosh
          with his father, Ells, Uncle Virg and Uncle Stanley. &quot;Uncle Stan
          was passing around the Hamms before we got to Osseo. Then we had to camp
          out. But we had a good time catching walleyes. I won the &quot;first
          fish&quot; prize ($1.00 per fisherman) by catching a northern pike. Those
          other guys were angry!&quot;
        </p>
      </ContentBox>

      {/*
      <Parallax
        bgImage={fishingDocks}
        bgImageAlt="Florida Fishing Docks"
        strength={200}
      >
        <div style={{
          height: '400px',
          position: 'relative',
          boxShadow: 'inset 0px 0px 20px 10px rgba(0,0,0,0.6)'
        }}>
        <Figure
          left
          style={{
            margin: '0 auto 0 3vw',
            color: 'var(--color-cream)',
            top: '50%',
            transform: 'translate(0, -50%)',
            maxWidth: '340px'
          }}
          img={johnsonFishing}
          caption='Virg - Did he catch it or buy it?'
        />
        </div>
      </Parallax>
      */}


      <ContentBox
        type="black"
        className="flexImages"
        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}
      >
        <Figure
          reveal="left"
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          img={LouieAndVirg_1926}
          caption=' Louie and Virg c. 1926'
        />
        <Figure
          reveal
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          img={fishingDocks}
          caption='Visiting sister Ev in Miami, March 1937'
        />
        <Figure
          reveal="right"
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          img={johnsonFishing}
          caption='Virg - Did he catch it or buy it?'
        />
      </ContentBox>

      <ContentBox type="black" style={{ paddingTop: '0', textAlign: 'center', color: 'var(--color-cream)' }}>
        <p>
          <strong>Virg:</strong> Why do fish swim in schools?
        </p>
        <p>
         <strong>Louie:</strong> I don&apos;t know.
        </p>
        <p>
          <strong>Virg:</strong> Because they can&apos;t walk!
        </p>
      </ContentBox>


      <ContentBox>
        <p>
          Dining was a favorite pastime. He was a regular at several &quot;steak
          joints&quot; in downtown Minneapolis. The routine was always the same. &quot;
          Make mine Manhattan.&quot; After a few cocktails he would order some &quot;horsey
          durvseys&quot;. His salad would have ranch or blue cheese dressing which paved the way for
          a prime rib &quot;au joooose&quot;. Preferably thick and rare. Baked
          potatoes with sour cream. Desserts? Well, he could take them or leave
          them. As for cigarettes? He never touched them. The guests varied but
          the talk was always of sports or the hunting season.
        </p>
      </ContentBox>


      <ContentBox type="white">
        <Figure
          right
          img={johnsonVivians}
          caption='Virg with the Vivians. July 1978 Cousins Vivian White and Vivian Schroeder.'
        />
        <p>
          Throughout the latter part of his life, Virg maintained a close relationship with
          his extended family, his nephews, his niece, and many cousins. There were
          fish fries at Lake Minnetonka, weekend picnics at lake homes in Minnesota
          and Wisconsin and &quot;beer and onion rings&quot; at various boating pavilions.
          Virg was a particular &quot;favorite cousin&quot; with his female cousins. All of
          them would light up when asked to describe him years later. One cousin
          remembered how touched she was every year to receive &quot;a personal handwritten
          Christmas card from Virg&quot;.
        </p>
        <p>
          In 1982, he co-hosted with his siblings and five first cousins a Johnson Centenary
          Reunion celebrating the immigration from Sweden (1881) of their grandparents Andrew and Malin.
          Blue and yellow Swedish flags hung over the banquet tables at Salem Lutheran Church as the sixty
          five descendants dined and revived the past. The next morning the heirs
          toured Minneapolis in 95 degree heat visiting the old Johnson Boarding
          House, Elmer and Agnes&apos; Colfax Avenue house (now the home of their
          grandson David Johnson), and other family residences. The next afternoon
          a large family picnic was held in Camden Park (formerly Webber Park) where
          Virg had played sports in his youth.
        </p>
        <Figure
          fullWidth
          img={familyReunion}
          caption='Ells, Virg, and Ev (center) and Families in Camden Park 1982'
        />
      </ContentBox>


      <ContentBox>
        <Figure
          left
          img={PicnicVirgEvAndElls}
          caption='Picnic with Virg, Ev, and Ells'
        />
        <Figure
          right
          img={trio}
          caption='Virg, Ev, and Ells - at Ells&apos; 80th Birthday 1987'
        />
        <p>
          In August 1987 his brother Ells celebrated his 80th birthday. &quot;We held
          the reception on the porch of the Officers Club at Fort Snelling,&quot;
          recalled his daughter Jerre Leonard. &quot;About fifty to sixty guests joined
          dad, Virg, and Ev in cutting the large birthday cake.&quot;
        </p>
        <p>
          During the Twins&apos;
          winning series that October, Helen died with her &quot;homer hanky&quot;
          tied to her walker. Virg greeted old friends and was present in the front
          row for her memorial service at Lakewood Cemetery. He then joined his sons and 
          family at a steak joint amid TV monitors that heralded another Twins victory.
        </p>
      </ContentBox>

      <ContentBox type="orange" flankingImages>
        <Figure
          left
          img={picnic}
          caption='David, Jo, and Ed Barnes, Ev, Johnny and Virg on Mt. Rainier August 1989'
        />
        <Figure
          right
          img={dinnerAtEddieBarnes}
          caption='Dining on Virg&apos;s mother&apos;s wedding china at Eddie and Jo Barnes. L-R: Cathy, Virg, Johnny, Evelyn, David, Eddie'
        />
        <p>
          Johnny took Virg to Tacoma in 1989 to visit his sister, Evelyn White, her sons,
          John and Ed Barnes, and their families. They drove to the Pacific Ocean,
          ate salmon, visited cousins Mark and Agnès in Tacoma, and toured the Olympia Brewery 
          where he sampled all of the free beer. &quot;Don&apos;t hold a torch to Grain Belt and Hamms.&quot;
          They picnicked on fried chicken under the evergreens on scenic Mount Rainier. And Virg drove up 
          to Seattle for a visit with Cully and family.
        </p>
      </ContentBox>
      <ContentBox flankingImages>
        <Figure
          left
          img={DianeCindyVirgVirg}
          caption='Cousin Diane, Cindy Darling, the two Virg&apos;s with the Birthday Cake'
        />
        <Figure
          right
          img={MarthaAndAlanSr}
          caption='Cousin Martha and Alan'
        />
        <h3>FAMILY EVENTS</h3>
        <p>
          In November 1989, Alan, Virg, and Carolyn drove down to Evanston, 
          IL for Johnny&apos;s 50th birthday party. A gala hosted by friends Frank, Peter, Mary, 
          and Geoff on Hamilton Street. When the cake was served there were champagne toasts, 
          then Johnny introduced Virg to the 80 guests who cheered and welcomed him back to the 
          Windy City. Applause. Champagne flowed.
        </p>
        <Figure
          left
          img={graduation1991}
          caption='Graduation Photo; Carolyn and Dave, Eden Prairie, MN 1991'
        />
        <Figure
          right
          img={theMinkBowTie}
          caption='A mink bow tie.'
        />
        <p>
          In June 1991, Alan, Beverly, and Johnny drove down to Mankato for Carolyn&apos;s 
          outdoor graduation from the University of Minnestota. They returned to attend Dave&apos;s 
          outdoor graduation from Eden Prairie High School. Another sunny day followed with a 
          family reception hosted by Al and Bev.  These occasions called for a photograph 
          session at Lee Brothers Studio of the family for which Virg wore his Mink Bow Tie.
        </p>
      </ContentBox>

      <ContentBox type="white">
        <p>
          &quot;...They call me Mr. Hockey...&quot; Virg was quoted in the Star Tribune in 1990.
          &quot;...Johnson said the game has changed since he played. Teams didn&apos;t wear face masks
          or helmets. Nowadays, you&apos;d get your face taken off if you didn&apos;t wear them...&quot;
          He said, &quot;The players are bigger now&quot;. Unlike today&apos;s players, he never
          got rich. &apos;...I sure didn&apos;t...&apos;, he said.&quot;...When we won the Stanley Cup in
          &apos;38 we got $500 and a watch...&quot;. In February 1944, Virg wrote to his parents telling
          them his &quot;$5,000 contract&quot; would pay more if they went to the playoffs.
          &quot;...Getting in the finals we could clean up a tidy sum- more than I could
          make working all summer...&quot;.
        </p>
        <div
          className="flexImages"
          style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}
        >
          <Figure
            reveal="left"
            style={{ flex: '1', margin: '20px', alignSelf: 'center' }}
            img={jerseyFront}
            caption=''
          />
          <Figure
            reveal
            style={{ flex: '1', margin: '20px' }}
            img={newspaper}
            caption="Virg with his hockey jersey 1990 - Jeff Wheeler Photo"
          />
          <Figure
            reveal="right"
            style={{ flex: '1', margin: '20px', alignSelf: 'center' }}
            img={jerseyBack}
            caption=''
          />
        </div>
      </ContentBox>


      <ContentBox>
        <Figure
          left
          img={vfw}
          caption='American Legion pals 1985'
        />
        <p>
          Following the death of his longtime companion, Mrs. Margie Carlson, in 1980, he became
          a regular for meals and nightcaps at the American Legion, Post 118, Ernest
          Aselton at Wayzata. Signs outside welcomed you with &quot;Friday Night Pork Chops
          and Shrimp.&quot; Although he was technically not a veteran, his pals there made
          him an honorary member. At the Legion, he met Walter Haselhuhn who recognized
          and advocated his hockey career. Wally sponsored a member&apos;s trip to Chicago
          in the late 1980&apos;s to attend a Blackhawk game. Back in the Chicago Stadium
          under the pipe organ and the banner honoring the Stanley Cup win of &apos;38,
          Virg was acknowledged as a &quot;hockey great&quot; and received the applause of the
          hockey players and the Windy City audience.
        </p>
        <p>
          The many friends he made at the Legion were an important component of his latter life.
          In many ways, they became his family. Virg was a man&apos;s man. He enjoyed
          the company of groups of men and many of those individuals sought his
          friendship. As an older person, he was looked to for advice, was a patient
          listener, and once again he became the &quot;coach&quot; to a varied
          group of buddies. He continued to &quot;pass the rabbit&apos;s foot&quot;
          along.
        </p>
      </ContentBox>

      <ContentBox type="white">
        <Figure
          width="60%"
          maxWidth="800px"
          right
          img={funeral}
          caption='(rear) Virgil C. Johnson, David V. Johnson, Duane G. Johnson, Alan D. Johnson; (front) John T. Barnes, Geraldine R. Leonard, Ellsworth C. Johnson, Jr. - Minneapolis, Minnesota September 18, 1993'
        />
        <p>
          Virg suffered a stroke at the Legion Post on June 4 and died on September 9, 1993 at
          Alan and Bev&apos;s home in Eden Prairie. He was 84 years old. A memorial Service was held
          at Lakewood Cemetery Chapel on September 18, 1993. His friend, Chaplain
          Cyril Gildner, commenced with the eulogy, Dvorak&apos;s &quot;Goin&apos;
          Home&quot; was sung by Michelle Kropski and testimonials were given by
          Virg&apos;s good friend, Wally Haselhuhn, and his son, Johnny. Many old
          friends, schoolmates, and hockey friends joined his family and relatives
          to reminisce about the glory days on ice at a reception given by his nephews,
          Duane, Ellsy, and Dave Johnson, and his niece, Jerre Leonard. His ashes
          were interred in the family plot at Lakewood Cemetery.
        </p>
      </ContentBox>


      <ContentBox id="part4">
        <HeadingBox>
          <h2>
            Part IV: Finale
          </h2>
        </HeadingBox>
        
        <Figure
          left
          img={stadiumDemo}
          caption='Chicago Stadium Demolition, March 1995'
        />
        <p>
          One interesting postscript was that The Chicago Stadium survived Virg by only one year 
          being demolished between February and May in 1995.
          Built in 1929 to house the Black Hawks, it later housed the Bulls, political conventions,
          circuses, ice shows and even funerals. The contents of the Art Deco monolith
          were sold on October 15, 1994 to an enthusiastic audience of 2,000 fans.
          Leslie Hindman Auctioneers conducted an on site auction that included
          the red wooden slat seats from 1929 ($250 each) and the red padded vinyl box
          seats for $100. Johnny purchased one of the red enameled seats that is currently the property of Cousin David Leonard.
          The 1938 Stanley Cup Banner was sold for $9,680. Demolition
          of the building followed.
        </p>
        <p>
          Virg's grand-daughter-in-law, Tracy, brought his #10 Black Hawk Jersey worn during 
          the Stanley Cup finals to the Antiques Roadshow in Austin, TX for an appraisal in 2017.  
          Alas, the team signed hockey stick was in Minnesota. 
          Jasmani Francis reviewed it pointing out that it is a Spalding Museum Quality wool jersey 
          from the 1938 game with an estimated auction value of between $7,000 and $10,000.
        </p>
        <p>
          Additional Research may be had by visiting the libraries at the Chicago Historical Museum and the Minnesota Historical Society.
        </p>
        <p>
          This website was created in 2000-2001 by Virg&apos;s two sons, two grandchildren and in
          discussion with other family members. Quotes are from family letters and newspaper
          clippings. We are particularly indebted to Lee Keenan
          as the splendid original web designer and to William McTeer who assisted and advised on
          the recent revisions. Special thank you to Roger Godin who helped with the final proofread of this document.
          Virg&apos;s grandson, Alan Jr., redesigned the website in 2022.
          Contact inquiries may be made to
          {' '}
          <a href="mailto:vcjohnson39@att.net">Virgil C. Johnson </a>.
        </p>
      </ContentBox>
      <BackToTop />
    </PageContent>
  );
}

export default PersonalHistory;
